module.exports = __webpack_public_path__ + "static/img/health3.7f81e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/health3.png
// module id = /XHv
// module chunks = 0